import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Package, PackageUpdatePackageRevenueCategories } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePackageRevenueCategories(): UseMutationResult<
  AxiosResponse<Package>,
  AxiosError<ErrorMessage>,
  PackageUpdatePackageRevenueCategories
> {
  const queryClient = useQueryClient();

  const updatePackageCategories = (
    p: PackageUpdatePackageRevenueCategories,
  ): Promise<AxiosResponse<Package>> => {
    return client.put(`packages/${p.packageId}/update-package-revenue-categories/`, p);
  };

  return useMutation(updatePackageCategories, {
    onSuccess: () => {
      queryClient.invalidateQueries('packageRevenueCategories');
      queryClient.invalidateQueries('packages');
    },
  });
}
